(function($) {
	formHelper.addRule({
		form: '.form-manage-travel-dates',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			},
			ERROR_MESSAGE_ONE: function() {
				if(this.data.systemMessage1) {
					$('#system-message-1').html(this.data.systemMessage1);
				}
			},
			ERROR_MESSAGE_TWO: function() {
				if(this.data.systemMessage2) {
					$('#system-message-2').html(this.data.systemMessage2);
				}
			},
			ERROR_MESSAGE_THREE: function() {
				if(this.data.systemMessage3) {
					$('#system-message-3').html(this.data.systemMessage3);
				}
			},
			ERROR_MESSAGE_FOUR: function() {
				if(this.data.systemMessage4) {
					$('#system-message-4').html(this.data.systemMessage4);
				}
			},
			ERROR_MESSAGE_FIVE: function() {
				if(this.data.systemMessage5) {
					$('#system-message-5').html(this.data.systemMessage5);
				}
			}
		}
	});

})(jQuery);

jQuery(function initEditFeaturedDestination($) {
	$('.edit-travel-dates-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-manage-travel-dates');
		var $deleteBtn             = $container.find('.delete-button');

		$deleteBtn.click(function() {
			var r = confirm("Did you want to Continue?");
			if (r === true) {
			    $('#delete-travel-date').val('yes');
				$form.submit();
			}
		});
	});
});




